import {
    Background,
    BackgroundColor,
    Container,
    Grid,
    GridColumns,
    Spacer,
    SpacerVariant,
    backgroundOptions,
    spacerOptions,
} from "../components/layout"
import { Repeater, types } from "react-bricks/frontend"

import { CenterTextProps } from "../text/CenterText"
import { ImageTextColumnItemProps } from "./ImageTextColumnItem"
import React from "react"
import { TypographyColor } from "../components/typography"

interface ImageTextColumnProps {
    background: { color: BackgroundColor } | BackgroundColor
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
    allwaysColumns: boolean
}

const ImageTextColumn: types.Brick<ImageTextColumnProps> = ({
    background,
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
    allwaysColumns,
}) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
            <Container>
                <Repeater
                    propName="centerText"
                    itemProps={
                        {
                            color:
                                bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                                    ? TypographyColor.White
                                    : TypographyColor.Darkgrey,
                        } as CenterTextProps
                    }
                />
                <Grid columns={GridColumns.Four} allwaysColumns={allwaysColumns} as="ul">
                    <Repeater
                        propName="repeater"
                        itemProps={
                            {
                                color:
                                    bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                                        ? TypographyColor.White
                                        : TypographyColor.Darkgrey,
                            } as ImageTextColumnItemProps
                        }
                    />
                </Grid>
            </Container>
            <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
        </Background>
    )
}

ImageTextColumn.schema = {
    name: "ImageTextColumn",
    label: "Image Text (4 Col)",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/ImageTextColumn.png`,
    repeaterItems: [
        {
            name: "centerText",
            items: [
                {
                    type: "CenterText",
                    label: "Text",
                    max: 1,
                },
            ],
        },
        {
            name: "repeater",
            items: [
                {
                    type: "ImageTextColumnItem",
                    label: "Image Text Item",
                    min: 1,
                    max: 4,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                display: types.OptionsDisplay.Color,
                options: backgroundOptions,
            },
        },
        {
            name: "allwaysColumns",
            label: "Mobile Two Columns",
            type: types.SideEditPropType.Boolean,
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: (): ImageTextColumnProps => ({
        background: { color: BackgroundColor.White },
        spacerTop: true,
        spacerBottom: true,
        allwaysColumns: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
    }),
}

export default ImageTextColumn
